const SUMMARY_TITLE_LINE_H = 3.5;
const SUMMARY_TITLE_GAP = 0;
const SUMMARY_TABLE_MIN_H = 28 + 3.6 + 2;
const SUMMARY_BLOCK_TOP_PAD = 2;

/** Altura mínima del bloque Summary (título + tabla + sello). */
export function estimatePackingSummaryBlockHeightMm() {
  return SUMMARY_TITLE_LINE_H + SUMMARY_TITLE_GAP + SUMMARY_TABLE_MIN_H;
}

export function packingListPageBottomY(pageHeightMm, margin) {
  return pageHeightMm - margin;
}

/** Si el bloque Summary no cabe en la hoja actual, continúa entero en una hoja nueva. */
export function yForPackingSummaryBlock(doc, afterDetailY, margin, pageHeightMm) {
  const yStart = afterDetailY + SUMMARY_BLOCK_TOP_PAD;
  if (yStart + estimatePackingSummaryBlockHeightMm() <= packingListPageBottomY(pageHeightMm, margin)) {
    return { y: yStart, newPage: false };
  }
  doc.addPage();
  return { y: margin, newPage: true };
}

export const packingSummaryLayoutConstants = {
  SUMMARY_TITLE_LINE_H,
  SUMMARY_TITLE_GAP,
  SUMMARY_BLOCK_TOP_PAD,
};
